/**
 * Utility functions for language level indicators
 */

import { CheckCircle, AlertCircle, HelpCircle } from "lucide-react";

/**
 * Determines the appropriate icon for a language level
 * @param languageLevel The language level (e.g., "A1", "A2", "B1", "B2", "C1", "C2")
 * @returns An object with the icon component and its color
 */
export const getLanguageLevelIcon = (languageLevel: string | undefined) => {
  if (!languageLevel) {
    return {
      icon: HelpCircle,
      color: "text-gray-400",
      tooltip: "Keine Angabe"
    };
  }

  const level = languageLevel.toUpperCase();

  // B2 or higher is good
  if (level === "B2" || level === "C1" || level === "C2") {
    return {
      icon: CheckCircle,
      color: "text-gray-500",
      tooltip: "Gutes Sprachniveau"
    };
  }

  // B1 or lower needs improvement
  if (level === "A1" || level === "A2" || level === "B1") {
    return {
      icon: AlertCircle,
      color: "text-gray-500",
      tooltip: "Sprachniveau verbesserungswürdig"
    };
  }

  // Default case
  return {
    icon: HelpCircle,
    color: "text-gray-400",
    tooltip: "Unbekanntes Sprachniveau"
  };
};
